import React, { useEffect, useState } from "react";
import CustomButtonOval from "../../components/form/CustomButtonOval";
import CustomSearchInput from "../../components/form/CustomSearchInput";
import { clientsResource } from "../../helpers/configRoutes/backend_helper";
import { useNavigate } from "react-router-dom";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import ModalClients from "./ModalClients";
import AddUpdClientModal from "./AddUpdClientModal";
import Columns from "./Columns";
import DataTableElement from "../../components/elements/DataTableElement";
import FiltersPagination from "../../components/elements/FiltersPagination";

const Clients = () => {
    const [modalConfirm, setModalConfirm] = useState({ show: false, title: 'Delete client', loadig: false, textLoad: 'Processing' })
    const [filters, setFilters] = useState({ perPage: 10, page: 1, search: '' });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [tableLoad, setTableLoad] = useState({ show: false, textLoad: 'Loading clients...' });
    const [clients, setClients] = useState([]);
    const [client, setClient] = useState({ id: null });

    useEffect(() => {
        const clients = async () => {
            setTableLoad({ ...tableLoad, show: true })
            const response = await clientsResource('get', { params: filters });
            setClients(response.clients);
            setMeta(response.meta);
            setTableLoad({ ...tableLoad, show: false })
        };
        clients();
    }, [filters]);


    const [modal, setModal] = useState({ show: false });

    const openModalAdd = (client = {}) => {
        setClient(client)
        setModal({ ...modal, show: true, title: client.id ? "Edit Client" : 'Add Client' })
    };



    const deleteCompany = async () => {
        setModalConfirm({ ...modalConfirm, loading: true })
        const response = await clientsResource('del', {}, modalConfirm.id);
        if (response.status) {
            setFilters({ ...filters })
        }
        setModalConfirm({ ...modalConfirm, loading: false, show: false, id: null })
    }

    const cols = Columns(setModalConfirm, modalConfirm, openModalAdd)
    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                <div className="max-w-auto mx-auto px-4 md:px-6 py-6">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                        <div>
                            <h1 className="text-2xl font-semibold text-cs-dark">
                                Clients
                            </h1>
                            <p className="text-sm text-cs-muted mt-1">
                                Manage your customers, contracts and key information from a single place.
                            </p>
                        </div>

                        <div className="flex items-center gap-3">
                            <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                                Total clients:{" "}
                                <span className="font-semibold text-cs-dark">
                                    {meta?.total || clients.length || 0}
                                </span>
                            </div>

                            <button
                                type="button"
                                onClick={() => openModalAdd({ id: null })}
                                className="
            inline-flex items-center gap-2
            px-4 py-2.5
            rounded-xl
            bg-cs-primary hover:bg-cs-primary-hover
            text-white text-sm font-medium
            shadow-md hover:shadow-lg
            transition-all
          "
                            >
                                <span className="material-symbols-outlined text-sm">add</span>
                                Add new client
                            </button>
                        </div>
                    </div>

                    {/* Tabla + filtros/paginación */}
                    <div
                        className="
        bg-cs-bg border border-cs-border rounded-2xl
        shadow-sm px-2 py-2
      "
                    >
                        <div className="overflow-x-auto">
                            <FiltersPagination
                                filters={filters}
                                setFilters={setFilters}
                                meta={meta}
                                showFilters={false}
                            >
                                <DataTableElement
                                    columns={cols}
                                    tableLoad={tableLoad}
                                    items={clients}
                                />
                            </FiltersPagination>
                        </div>
                    </div>

                    {/* Modals */}
                    <AddUpdClientModal
                        clientItem={client}
                        modal={modal}
                        setModal={setModal}
                        filters={filters}
                        setFilters={setFilters}
                    />

                    <ConfirmDeleteModal
                        modal={modalConfirm}
                        setModal={setModalConfirm}
                        action={deleteCompany}
                    />
                </div>
            </div>

        </>
    );
}

export default Clients;